import React, { Component } from "react";
import _ from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./styles/multiselectTable.css";

class MultiselectTableBody extends Component {
  renderCell = (item, column) => {
    if (column.content) return column.content(item);
    return _.get(item, column.path);
  };

  createTdKey = (item, column) =>
    `multiselectTableTdKey_${column.path || column.key}_${item[this.props.idPropName]}`;

  createTotalsTdKey = (path) => `multiselectTableTdTotal_${path}`;

  calcTotal = (column) => {
    const { data } = this.props;
    const reducer = (accumulator, currValue) => accumulator + currValue;
    const valuesToAdd = data.map((i) => {
      if (column.calculated) return column.equation(i);
      if (!isNaN(i[column.path])) return parseFloat(i[column.path]);
      return 0;
    });
    if (valuesToAdd.length > 0) {
      if (column.totalsFormatter)
        return column.totalsFormatter(valuesToAdd.reduce(reducer));
      return valuesToAdd.reduce(reducer);
    }
    return 0;
  };

  isSelected = (id) => {
    const { selectedItems, idPropName } = this.props;
    return selectedItems.find((i) => i[idPropName] === id) !== undefined;
  };

  isDeleted = (id) => {
    const { deletedItems, idPropName } = this.props;
    if (deletedItems) return deletedItems.find((i) => i[idPropName] === id) !== undefined;
    return false;
  };

  getTrClass = (id) => {
    let trClass = "";
    if (this.isDisabled(id))
      trClass = trClass + " cursor-not-allowed text-muted bg-white";
    else {
      if (this.isSelected(id)) trClass += " table-primary";
      else if (this.isDeleted(id)) trClass += " table-warning";
      trClass += " pointer-cursor";
    }
    return trClass;
  };

  isDisabled = (id) => {
    const { disabledItems, idPropName } = this.props;
    return (disabledItems || []).find((i) => i[idPropName] === id) !== undefined;
  };

  handleClick_tr = (item) => (e) => {
    e.preventDefault();
    const { selectedItems, idPropName, onSelect, onDeselect } = this.props;
    // For touch devices, only capture "taps" - not scrolling movements
    if (!this.isDisabled(item[idPropName])) {
      // If item is already selected, then remove
      if (selectedItems.find((d) => d[idPropName] === item[idPropName]) !== undefined)
        onDeselect && onDeselect(item);
      else onSelect && onSelect(item);
    }
  };

  handleClick_showMore = (e) => {
    e.preventDefault();
    const { getNextPage } = this.props;
    getNextPage && getNextPage();
  };

  handleClick_showAdd = (e) => {
    e.preventDefault();
    const { addCallback } = this.props;
    addCallback && addCallback();
  };

  renderCheckCol = (item) => {
    let icon;
    const { selectedItems, deletedItems, disabledItems, idPropName } = this.props;
    const isSelected =
      selectedItems && selectedItems.some((i) => i[idPropName] === item[idPropName]);
    const isDeleted =
      deletedItems && deletedItems.some((i) => i[idPropName] === item[idPropName]);
    const isDisabled =
      disabledItems && disabledItems.some((i) => i[idPropName] === item[idPropName]);
    if (isSelected)
      icon = <FontAwesomeIcon icon="check" className="fa-fw text-primary" />;
    else if (isDeleted)
      icon = <FontAwesomeIcon icon="times" className="fa-fw text-warning" />;
    else icon = <FontAwesomeIcon icon="check" className="fa-fw icon-invisible" />;

    // Override prev two conditions with isDisabled
    if (isDisabled && isSelected)
      icon = <FontAwesomeIcon icon="check" className="fa-fw text-muted" />;
    return <td key={`multiselectTdKey_checkCol`}>{icon}</td>;
  };

  render() {
    const {
      data,
      columns,
      idPropName,
      isPaginated,
      currPage,
      pageCount,
      searchString,
      showAdd,
    } = this.props;
    const columnsWithTotals = columns.filter((c) => c.showTotals === true);

    // Testing >= instead of ===, for when pageCount == 1 and currPage == 0 (happens
    // when there are zero results.)
    const isLastPage = isPaginated && currPage >= pageCount;

    return (
      <tbody>
        {data.map((item, index) => (
          <tr
            className={this.getTrClass(item[idPropName])}
            key={`multiselectTableTrKey_${index}_${item[idPropName]}`}
            onClick={this.handleClick_tr(item)}
          >
            {[
              this.renderCheckCol(item),
              ...columns.map((column) => (
                <td key={this.createTdKey(item, column)} className={column.tdClassName}>
                  {this.renderCell(item, column)}
                </td>
              )),
            ]}
          </tr>
        ))}
        {isPaginated && !isLastPage && (
          <tr
            className="pointer-cursor"
            id="showMore"
            key={`multiselectTableTrKey_showMore`}
          >
            <td
              colSpan={columns.length + 1}
              className="w-100"
              style={{ textAlign: "center" }}
            >
              <button
                name="showMore"
                id="showMore"
                className="btn btn-sm btn-link py-0"
                onClick={this.handleClick_showMore}
              >
                Show More...
              </button>
            </td>
          </tr>
        )}
        {showAdd ? (
          <tr className="pointer-cursor" id="showAdd" key="multiselectTableTrKey_showAdd">
            <td
              colSpan={columns.length + 1}
              className="w-100"
              style={{ textAlign: "center" }}
            >
              <button
                name="showAdd"
                id="showAdd"
                className="btn btn-sm btn-link py-0"
                onClick={this.handleClick_showAdd}
              >
                {`Add \"${searchString}\"...`}
              </button>
            </td>
          </tr>
        ) : null}
        {columnsWithTotals.length > 0 && (
          <tr
            className="pointer-cursor"
            id="isTotalsRow"
            key={`multiselectTableTrKey_totals`}
          >
            {columns.map((c) => {
              if (c.showTotals === true)
                return (
                  <td key={this.createTotalsTdKey(c.path)} className={c.tdClassName}>
                    {this.calcTotal(c)}
                  </td>
                );
              if (c.showTotalsLabel)
                return (
                  <td key={this.createTotalsTdKey(c.path)}>
                    <b>Total =</b>
                  </td>
                );
              if (c.totalsUnit !== null)
                return <td key={this.createTotalsTdKey(c.path)}>{c.totalsUnit}</td>;
              return <td />;
            })}
          </tr>
        )}
      </tbody>
    );
  }
}

export default MultiselectTableBody;
